export { default } from './UserAuthTypeForm';



// WEBPACK FOOTER //
// ./src/components/UserAccount/UserAuthTypeForm/index.js